import type { TranslationKey } from '@/lib/i18n';

export const EMPTY_CART_TITLE = [
  'sidecart:cart.empty',
  'Your cart is empty',
] as const satisfies TranslationKey;

export const EMPTY_CART_DESCRIPTION = [
  'sidecart:cart.emptyDescription',
  'Add items to your cart to get started',
] as const satisfies TranslationKey;

export const EMPTY_CART_CONTINUE_SHOPPING = [
  'sidecart:cart.continueShopping',
  'Continue Shopping',
] as const satisfies TranslationKey;
